// note: used in platform init; be sure not to import code that may use platform libraries from here

// setup in marketplaceApp.tsx and learnerApp.tsx
export const Sentry = (window as any).Sentry;

export function setGlobalUserForSentry(userId: string | null) {
  Sentry?.getCurrentScope().setUser(userId ? { id: userId } : null);
}
